import { Component, DoCheck, Input, OnInit } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup } from "@angular/forms";

import { PropertiesService } from "@core/services/properties.service";

import { Subscription } from "rxjs";

import ActionTypesEnum from "@shared/enums/action-constant.enum";
import { CustomEventService } from "@shared/services/custom-event.service";
import { QWiserService } from "@shared/services/q-wiser.service";
import { createV2FormGroup, validateFormControl, validateFormGroup } from "@shared/utils/form.util";

import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
  selector: 'app-initialize-qwiser-modal',
  templateUrl: './initialize-qwiser-modal.component.html'
})
export class InitializeQwiserModalComponent implements OnInit, DoCheck {
  @Input() fields?: any;
  @Input() steps: any;
  @Input() isUpdate: boolean;
  @Input() analysisId: string;
  @Input() loading: boolean;
  @Input() scopeId: string;
  selectedFields: Map<string, any> = new Map();
  localSelectedFields: Map<string, any> = new Map();
  @Input() currentQwiserStepIndex = 0;
  @Input() currentStep: any;
  @Input() stepInnerLoading = false;
  currentStepDisabled: boolean;
  customEventSubscription: Subscription;
  addQwiserAnalysisForm: FormGroup;
  formData: any;
  disabledPlanningDay = false;
  sortedList: any;
  @Input() team: any;
  @Input() settings?: AgileSpaceDetail.AnalysisSettings;
  compareFn = (o1: any, o2: any) => (o1 && o2 ? o1.key === o2.key : o1 === o2);


  constructor(private customEventService: CustomEventService,
              private fb: FormBuilder,
              public propertiesService: PropertiesService,
              private qwiserService: QWiserService) { }



  // get datasource(): FormArray {
  //   return this.addQwiserAnalysisForm.get('datasource') as FormArray;
  // }
  // get project(): FormArray {
  //   return this.addQwiserAnalysisForm.get('project') as FormArray;
  // }
  // get branch(): FormArray {
  //   return this.addQwiserAnalysisForm.get('branch') as FormArray;
  // }

  ngDoCheck(): void {
    this.addQwiserAnalysisForm = createV2FormGroup(this.fields)
  }
  ngOnInit(): void {
    this.customEventService.eventAnnounced$
      .pipe(untilDestroyed(this)).subscribe(
      ({ action, data }) => {
        if (action === ActionTypesEnum.WIDGET_CREATE_ONE_ITEM_SELECTED) {
          this.selectField(data.event, data.field);
        }
      });

    this.addQwiserAnalysisForm = this.fb.group({
      datasource: [],
      project: [],
      branch: [],
      analysisDateRange: []
    });
  }

  isStepDisabled(index: number): boolean {
    return index > this.currentQwiserStepIndex;
  }
  changeCurrentQwiserStep($event: 'increase' | 'decrease' | 'not-change' | number) {
    if (typeof $event === 'number' && $event > this.currentQwiserStepIndex) {
      if (!this.isStepValid()) {
        return;
      }
    }
    this.stepInnerLoading = true;
    switch ($event) {
      case 'increase': {
        this.currentQwiserStepIndex = ++this.currentQwiserStepIndex;
        break;
      }
      case 'decrease': {
        this.customEventSubscription?.unsubscribe();
        this.currentQwiserStepIndex = --this.currentQwiserStepIndex;
        break;
      }
      case 'not-change': {
        break;
      }
      default: {
        this.currentQwiserStepIndex = $event;
      }
    }
    this.currentStep = this.currentQwiserStepIndex !== 0 && this.steps[this.currentQwiserStepIndex - 1];

    if (!this.currentStep) {
      return;
    }

    if (this.currentQwiserStepIndex !== 0) {
      this.qwiserService.getFieldUrl(this.currentStep.fieldUrl).
      pipe(untilDestroyed(this)).subscribe(res => {
        this.fields = res.fields;
        this.fields.forEach(field => {
          field.required = field.validators?.find(item => item === 'required');

          const regex = field.validators?.find(item => item.startsWith('regex::'));

          if (regex) {
            field.regex = regex.substring(7, regex.length);
          }

          if (field?.data?.selections) {
            const matched = field.multiSelect ? field?.data?.selections : field?.data?.selections[0]
            this.selectField(matched, field)
          }

          if (field?.data?.content) {
            if (field?.data?.content?.length === 1) {
              const matched = field.multiSelect ? field?.data?.content : field?.data?.content[0]
              this.selectField(matched, field)
            }

            if (field?.data?.content?.length > 1) {
              this.sortedList = ( field.name === 'Analysis Date Range' ) ? field?.data?.content : field?.data?.content.sort((a,b) => a.label.toLocaleLowerCase() > b.label.toLocaleLowerCase() ? 1 : -1);
              const filtered = this.sortedList.filter(item => item.selected)
              if (filtered && filtered.length > 0) {
                const matched = field.multiSelect ? filtered : filtered[0]
                this.selectField(matched, field)
              }
            }
          }

          const oldValue = this.localSelectedFields.get(field.key);
          if (oldValue !== undefined) {
            this.selectField(oldValue, field)
          }

          if (field.data?.isFetchInitialData) {
            this.customEventService.announceEvent(ActionTypesEnum.NEXT_DATA_STEP_DATA, {
              field,
              form: this.addQwiserAnalysisForm,
            });
          }
        });
      });
      this.stepInnerLoading = false;
    }
  }

  changeStep(type: string): void {
    switch (type) {
      case 'create': {
        this.cancelForm();
        validateFormGroup(this.addQwiserAnalysisForm);
        if (this.addQwiserAnalysisForm.invalid) {
          return;
        }
        const payload = { "scopeId": this.scopeId };
        this.selectedFields.forEach((values, keys) => {
          payload[keys] = (keys === "dateRange") ? values.key : values
        })

        if (this.isUpdate && this.analysisId) {
          payload["analysisId"] = this.analysisId
          this.customEventService.announceEvent(ActionTypesEnum.UPDATE_V2_AGILE_ANALYSIS, payload);
        } else {
          this.customEventService.announceEvent(ActionTypesEnum.ADD_V2_AGILE_ANALYSIS, payload);
        }
        break;
      }
      case 'next': {
        validateFormGroup(this.addQwiserAnalysisForm);

        if (!this.isStepValid()) {
          console.log('Step is not Valid')
          return;
        }
        this.changeCurrentQwiserStep('increase');
        this.selectedFields.forEach((values, keys) => {
          this.localSelectedFields.set(keys, values)
        });

        break;
      }
      case 'previous': {
        this.changeCurrentQwiserStep('decrease');
        break;
      }
    }
  }

  selectField(value, field): void {
    this.selectedFields.set(field.key, value);
    this.customEventService.announceEvent(ActionTypesEnum.ANALYSIS_CREATE_V2_FIELD_SELECTED, {
      field,
      form: this.addQwiserAnalysisForm,
      value
    });
  }

  isStepValid(): boolean {
    if (this.currentQwiserStepIndex === 0) {
      return true;
    }

    for (const field of this.fields) {
      validateFormControl(this.addQwiserAnalysisForm.get(field.key));
      if (this.addQwiserAnalysisForm.invalid) {
        const formControls = this.addQwiserAnalysisForm.controls;
        if (this.addQwiserAnalysisForm.invalid) {
          Object.keys(formControls).forEach(controlName => {
            const control = formControls[controlName] as FormControl;
            if (control.status === 'INVALID') {
              control.markAsDirty();
              control.setErrors({ required: true });
            }
          });
        }
        return false;
      }
      if (this.addQwiserAnalysisForm.get(field.key).dirty
        && this.addQwiserAnalysisForm.get(field.key).errors) {
        return false;
      }
    }
    return true;
  }


  resetForm(): void {
    this.addQwiserAnalysisForm.reset();
  }

  cancelForm(): void {
    this.customEventService.announceEvent(ActionTypesEnum.CLOSE_MODAL);
  }




}
